 
import { createRouter, createWebHashHistory } from 'vue-router'
import GptIndex from '@/components/GptIndex/GptIndex'
import GptChartIndex from '@/components/GptChartIndex/GptChartIndex'
import GptLogin from '@/components/GptLogin/GptLogin'
 import ApplyBeta from '@/components/ApplyBeta/ApplyBeta'
 import GptHome from '@/components/GptHome/GptHome'
 import GptChart from '@/components/GptChart/GptChart'
 import OperateGuide from '@/components/OperateGuide/OperateGuide'
 import AboutUs from '@/components/AboutUs/AboutUs'
 import PersonalCenter from '@/components/PersonalCenter/PersonalCenter'
const routes=[
	{
	  path: '/GptIndex/GptIndex',
	  name: 'GptIndex',
	  component: GptIndex,
	  meta:
	    {
	      navShow: false, //是否显示底部导航
	      requireAuth: false,//是否要登录
		  title:'首页'
	    },
	},
	{
	  path: '/GptChartIndex/GptChartIndex',
	  name: 'GptChartIndex',
	  component: GptChartIndex,
	  meta:
	    {
	      navShow: false, //是否显示底部导航
	      requireAuth: false,//是否要登录
		  title:'模式选择'
	    },
	},
	{
	  path: '/GptLogin/GptLogin',
	  name: 'GptLogin',
	  component: GptLogin,
	  meta:
	    {
	      navShow: false, //是否显示底部导航
	      requireAuth: false,//是否要登录
		  title:'登录'
	    },
	},
	{
	  path: '/ApplyBeta/ApplyBeta',
	  name: 'ApplyBeta',
	  component: ApplyBeta,
	  meta:
	    {
	      navShow: false, //是否显示底部导航
	      requireAuth: false,//是否要登录
		  title:'内测申请'
	    },
	},
	
	//聊天
	{
		path: '/GptHome/GptHome',
		type: 'GptHome', // 根据type区分不同模块（顶部导航）
		component: GptHome,
		redirect:'/GptChart/GptChart' ,
		children: [{
			path: '/GptChart/GptChart',
			name: 'GptChart',
			component: GptChart,
			menuName: '',
		}, ],
		meta: {
			requireAuth: true, //是否要登录
			title:'岐黄问道大模型'
		},
	},
	//操作指南
	{
		path: '/GptHome/GptHome',
		type: 'GptHome', // 根据type区分不同模块（顶部导航）
		component: GptHome,
		redirect:'/OperateGuide/OperateGuide' ,
		children: [{
			path: '/OperateGuide/OperateGuide',
			name: 'OperateGuide',
			component: OperateGuide,
			menuName: '操作指南',
		}, ],
		meta: {
			requireAuth: true, //是否要登录
			title:'操作指南'
		},
	},
	//关于我们
	{
		path: '/GptHome/GptHome',
		type: 'GptHome', // 根据type区分不同模块（顶部导航）
		component: GptHome,
		redirect:'/AboutUs/AboutUs' ,
		children: [{
			path: '/AboutUs/AboutUs',
			name: 'AboutUs',
			component: AboutUs,
			menuName: '关于我们',
		}, ],
		meta: {
			requireAuth: true, //是否要登录
			title:'关于我们'
		},
	},
	//个人中心
	{
		path: '/GptHome/GptHome',
		type: 'GptHome', // 根据type区分不同模块（顶部导航）
		component: GptHome,
		redirect:'/PersonalCenter/PersonalCenter' ,
		children: [{
			path: '/PersonalCenter/PersonalCenter',
			name: 'PersonalCenter',
			component: PersonalCenter,
			menuName: '个人中心',
		}, ],
		meta: {
			requireAuth: true, //是否要登录
			title:'个人中心'
		},
	},
	
	//路由重定向
	{
		path: '/',
		redirect: {
			path: '/GptIndex/GptIndex'
		}
	},
	
	
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
	routes
})
 
export default router